import { Effect } from "../../../../../../../redux/types/effect.type";
import { catchError, filter, ignoreElements, map, mergeMap, tap } from "rxjs/operators";
import { isActionType } from "../../../../../../../redux/action.functions";
import * as templateService from "../../../../../features/flyer-template/services/flyer-template.service";
import * as actions from "./flyer-detail-add-page.actions";
import { of } from "rxjs";
import { FlyerDetailAddPageActions } from "./flyer-detail-add-page.actions";
import { EffectActionsObservable } from "../../../../../../../redux/types/effect-actions-observable.type";
import * as navigationService from "../../../../../../../features/navigation/services/navigation.service";
import * as service from "../services/flyer-detail-add-page.service";
import { FlyerDetailCreatePageResponse } from "../types/flyer-detail-create-page-response.interface";

const fetchTemplates: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailAddPageActions.FetchTemplates)),
    mergeMap(() =>
      templateService.fetchAllTemplates().pipe(
        map((templates) => actions.fetchTemplatesSuccess(templates)),
        catchError((error) => of(actions.fetchTemplatesFailure(error)))
      )
    )
  );

const goToFlyer: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailAddPageActions.GoToFlyer)),
    map((action) => action.payload),
    tap((flyerId) => navigationService.goToFlyer(flyerId)),
    ignoreElements()
  );

const createPage: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailAddPageActions.CreatePage)),
    map((action) => action.payload),
    mergeMap(({ flyerId, templateId }) =>
      service.createPage(flyerId, templateId).pipe(
        map((page) => actions.createPageSuccess(page)),
        catchError((error) => of(actions.createPageFailure(error)))
      )
    )
  );

const createPageSuccess: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailAddPageActions.CreatePageSuccess)),
    map((action) => action.payload),
    tap((page: FlyerDetailCreatePageResponse) =>
      navigationService.goToFlyerPage(page.flyer, page.id)
    ),
    ignoreElements()
  );

export const FlyerDetailAddPageEffects = [fetchTemplates, goToFlyer, createPage, createPageSuccess];
